import React, { useEffect, useState } from 'react'
import { API, Auth } from 'aws-amplify'
import { CognitoUserAmplify } from '@aws-amplify/ui';
import { useNavigate } from 'react-router-dom';

import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

type SampleDataType = [
  {
    saggitaId: string;
    name: string;
  }
];
const initialSampleData = {saggitaId: "", name: ""};

type SaggitaListProps = {
  signOut: VoidFunction;
  user: CognitoUserAmplify;
  activeLink: VoidFunction;
};

const SaggitaList: React.FC<SaggitaListProps> = (props) => {
  const [sampleData, setSampleData] = useState<SampleDataType>([initialSampleData])
  const [orgSampleData, setOrgSampleData] = useState<SampleDataType>([initialSampleData])
  const [filterText, setFilterText] = React.useState('');
  const [errorText, setErrorText] = React.useState('');
  const [alertClass, setAlertClass] = React.useState('alert alert-danger d-none');

  const navigate = useNavigate();

  useEffect(() => {
    getSampleData();
    props.activeLink();
  }, [])

  useEffect(() => {
  }, [sampleData]);

  const getSampleData = async () => {
    try {
      const apiName = 'MainApi';
      const path = '/saggita/all';
      const myInit = {
        headers: { 
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };
    
      const data = await API.get(apiName, path, myInit);
      const sortedData = data.sort((a: any, b: any)=> a.saggitaId < b.saggitaId ? -1 : 1)
      setSampleData(sortedData);
      setOrgSampleData(sortedData);
    }
    catch (err) {
      console.log('error getting data')
      setAlertMessage('AG01001 データの取得に失敗しました。');

      const sortedData: any = [];
      // const sortedData = dataDummy.sort((a: any, b: any)=> a.saggitaId < b.saggitaId ? -1 : 1)
      setSampleData(sortedData);
      setOrgSampleData(sortedData);
    }
  }

  const handleChangeFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(e.target.value);

    setSampleData(
      orgSampleData.filter((item) => {
        return item.name.includes(e.target.value) || item.saggitaId.includes(e.target.value);
      }
    ) as SampleDataType);
  }

  const handleClickBtn = (id: string) => {
    navigate('/saggita/mng', {state: { 'id': id }});
  }

  const setAlertMessage = (message: string) => {
    setErrorText(message);
    setAlertClass('alert alert-danger');
  }

  const handleClickTest = () => {
    let value = {saggitaId: "aaa", name: "vvv"};
    const data = sampleData.concat();
    data.push({saggitaId: "aaa", name: "vvv"});
    setSampleData(data as SampleDataType);
  }

  return (
    <div className="p-3">
      <h4>通信ユニットの管理</h4>
      <div className={alertClass} role="alert">{errorText}</div>
      <div>
        <div className='form-group mt-3' style={{ 'width': '700px' }}>
          <input type="text" id="filter_text" value={filterText} placeholder='フィルター' onChange={(e) => handleChangeFilterText(e)}></input>
        </div>
      </div>
      {
        (() => {
          if (sampleData.length) {
            if (sampleData[0].saggitaId === '') {
              return;
            }
            else {
              let list = sampleData.map((data, index) => (
                <div key={data.saggitaId ? data.saggitaId : index}>
                  <input type="button" className="btn btn-link"  key={'btn' + data.saggitaId ? data.saggitaId : index} value={data.saggitaId + ' ' + data.name}  onClick={() => handleClickBtn(data.saggitaId)} />
                </div>
              ));
              return (list);
            }
          }
          else {
            return (
              <h6>データがありません。</h6>
            );
        }
        })()
      }
    </div>
  );
}

export default SaggitaList;
